import React, { useCallback, FC } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import SnackbarRender from './SnackbarRender'
import snackbarActions from '../../store/modules/snackbar'
import snackbarSelectors from '../../store/selectors/snackbar'

const SnackbarWrapper: FC<React.PropsWithChildren<unknown>> = ({

}) => {
  const dispatch = useDispatch()
  const {
    open = false,
    text = '',
    type = 'default'
  } = useSelector(snackbarSelectors.data)

  const onClose = useCallback(() => {
    dispatch(snackbarActions.onClose())
  }, [])

  return (
    <SnackbarRender
      open={ open }
      text={ text }
      type={ type }
      onClose={ onClose }
    />
  )
}

export default SnackbarWrapper